/**
 * Load Sentry only when VITE_SENTRY_ID is configured (skipped in local dev).
 */
export function initSentry(): void {
  const sentryId = import.meta.env.VITE_SENTRY_ID;
  if (!sentryId) {
    return;
  }

  const script = document.createElement('script');
  script.src = `https://js.sentry-cdn.com/${sentryId}.min.js`;
  script.crossOrigin = 'anonymous';
  script.onload = () => {
    const Sentry = (window as Window & { Sentry?: { init: (opts: object) => void } }).Sentry;
    if (!Sentry) {
      console.warn('Sentry script loaded but Sentry global is missing');
      return;
    }
    Sentry.init({
      environment: import.meta.env.VITE_SENTRY_ENV_NAME || 'development',
      tracesSampleRate: 1,
    });
  };
  script.onerror = () => {
    console.warn('Failed to load Sentry SDK');
  };
  document.head.appendChild(script);
}
